'use client'

import { type ReactNode } from 'react'

import { AuthProvider } from './AuthProvider'
import { ClientProvidersReadyProvider } from './ClientProvidersReadyContext'
import QueryProvider from './QueryProvider'

type DeferredClientProvidersProps = {
  children: ReactNode
}

/**
 * Client auth/query shell for the locale layout.
 *
 * Previously Auth/Query were deferred until the first user gesture on guest
 * home (Lighthouse). That remounted the whole tree on first click — header
 * flicker, late language selector, “app wakes after interaction”.
 *
 * Providers stay mounted for the whole session so children are not remounted.
 * Heavy non-chrome UI (Footer, CookieConsent, analytics) stays deferred.
 */
export default function DeferredClientProviders({
  children
}: DeferredClientProvidersProps) {
  return (
    <ClientProvidersReadyProvider ready>
      <QueryProvider>
        <AuthProvider>{children}</AuthProvider>
      </QueryProvider>
    </ClientProvidersReadyProvider>
  )
}
